import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  groups: [],
  last7Days: {},
  now: {},
  calculatedAt: null,
  isLoading: false,
};

const toTimestamp = (value) => (value === null ? null : new Date(value).getTime());

const shouldApplyDashboardPayload = (currentCalculatedAt, incomingCalculatedAt) => {
  // Backward compatibility: if neither side has calculatedAt, keep legacy behavior and accept the update.
  if (incomingCalculatedAt === null && currentCalculatedAt === null) return true;

  // Once state is timestamped, reject untimestamped payloads to avoid stale overwrites.
  if (incomingCalculatedAt === null) return false;

  // If state is still untimestamped but incoming is timestamped, accept and move state to timestamped mode.
  if (currentCalculatedAt === null) return true;

  // Normal case: only accept updates that are newer (or same instant) than current state.
  return toTimestamp(incomingCalculatedAt) >= toTimestamp(currentCalculatedAt);
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET DASHBOARD INFOMRATION
    getDashboardSuccess(state, action) {
      const dashInfo = action.payload;
      state.isLoading = false;

      if (!shouldApplyDashboardPayload(state.calculatedAt, dashInfo.calculatedAt)) {
        return;
      }

      state.groups = dashInfo.groups;
      state.last7Days = dashInfo.last7Days;
      state.now = dashInfo.now;
      state.calculatedAt = dashInfo.calculatedAt;
    },
  },
});

// Reducer
export default slice.reducer;
export const dashboardActions = slice.actions;

// ----------------------------------------------------------------------

export function getDashboard(companyId) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/dashboard/${companyId}`);
      dispatch(slice.actions.getDashboardSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
